import React from "react";
import {Box, ResponsiveContext, ThemeContext} from "grommet";
import Head from "../Head";
import Footer from "../Footer";
import Loading from "../Loading";
import {DarkModeCompatibleImage} from "../../utils/styled";
import StreamlinedLogo from "../icons/StreamlinedLogo";

// No mounted guard on the dark variants below: the server now renders the real mode, so
// deferring them to post-mount would paint a black logo on a dark background first.
const LoginPageLayout = (props) => {
    const {
        children,
        title,
        isLoading,
        description,
        merchantLogo
    } = props;

    return (
        <Box>
            <Head title={title} description={description} />
            <ResponsiveContext.Consumer>
                {(size) => (
                    <Box>
                        <ThemeContext.Consumer>
                            {(theme) => (
                                <Box align="center" margin={{horizontal: size === "small" ? "medium" : 'xlarge', vertical: (size==="small" ? "large" : "medium")}}>
                                    <Box direction="row" gap="medium" alignSelf="center" margin={{bottom: (size==="small" ? "large" : "medium")}}>
                                        {!merchantLogo && (
                                            <StreamlinedLogo size="small" color={theme.dark ? "white" : "black"} />
                                        )}
                                        { merchantLogo && (
                                            <Box gap="medium" direction="row" align="center">
                                                <Box width={{max: '12em'}}>
                                                    <DarkModeCompatibleImage fit="contain" fill src={merchantLogo} dark={theme.dark}/>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                    {/* On a phone the card's border sat 12px from the screen edge with
                                    12px inside it, so the form goes full width with no card. */}
                                    <Box
                                        data-testid="login-card"
                                        width={size === "small" ? "100%" : "24em"}
                                        margin={{bottom: "small"}}
                                        pad={{vertical: "medium", horizontal: "medium"}}
                                        border={size === "small" ? false : {size: "small"}}
                                        round={size === "small" ? false : {size: "small"}}
                                    >
                                        {children}
                                        {isLoading && <Loading />}
                                    </Box>
                                    <Footer align="center" />
                                </Box>
                            )}
                        </ThemeContext.Consumer>
                    </Box>
                )}
            </ResponsiveContext.Consumer>
        </Box>
    );
};

export default LoginPageLayout;
